import ExcelJS from 'exceljs';
import { getFloatCMV } from './cmv/convertQtd';

export async function exportFileEntranceCMV(items, filename) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Relatório');
  const days = Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, '0'));

  // ---- cabeçalho fixo ----
  const staticHeaders = [
    'NOME', // 1
    'UNIDADE', // 2
    'SAÍDA AUT. TOTAL', // 3
    'SAÍDA MANUAL TOTAL', // 4
    'SAÍDA PERDA TOTAL', // 5
    'SAÍDA CORTESIA TOTAL', // 6
    'SAÍDA REAL TOTAL', // 7
    'CUSTO AUT. TOTAL', // 8
    'CUSTO MANUAL TOTAL', // 9
    'CUSTO PERDA TOTAL', // 10
    'CUSTO CORTESIA TOTAL', // 11
    'CUSTO REAL TOTAL', // 12
  ];

  worksheet.mergeCells(1, 1, 1, staticHeaders.length);
  worksheet.getCell('A1').value = 'DIAS';
  worksheet.getCell('A1').alignment = { horizontal: 'center', vertical: 'middle' };

  staticHeaders.forEach((header, i) => {
    const cell = worksheet.getCell(2, i + 1);
    cell.value = header;
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
  });

  const dayHeaders = [
    'Valor',
    'Saída Aut.',
    'CMV Aut.',
    'Saída Man.',
    'CMV Man.',
    'Saída Perda',
    'CMV Perda',
    'Saída Cortesia',
    'CMV Cortesia',
  ];

  let colIndex = staticHeaders.length + 1;
  days.forEach(day => {
    worksheet.mergeCells(1, colIndex, 1, colIndex + dayHeaders.length - 1);
    worksheet.getCell(1, colIndex).value = day;
    worksheet.getCell(1, colIndex).alignment = { horizontal: 'center', vertical: 'middle' };

    dayHeaders.forEach((h, idx) => {
      const cell = worksheet.getCell(2, colIndex + idx);
      cell.value = h;
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    colIndex += dayHeaders.length;
  });

  // ---- linhas dos itens ----
  items.forEach((item, rowIdx) => {
    const excelRow = rowIdx + 3;
    let custoTotalManual = 0;
    let custoTotalPerda = 0;
    let custoTotalPromocional = 0;

    worksheet.getCell(excelRow, 1).value = item.name;
    worksheet.getCell(excelRow, 2).value = item.unit;

    let colIndex = staticHeaders.length + 1;

    days.forEach(day => {
      const dayData = item?.days?.[day] ?? {};
      const priceUn = dayData.priceUn ?? 0;
      const qtdExitAutomatic = getFloatCMV(dayData.qtdExitAutomatic);
      const qtdExit = getFloatCMV(dayData.qtdExit);
      const qtdLoss = getFloatCMV(dayData.qtdLoss);
      const qtdPromocional = getFloatCMV(dayData.qtdPromotial ?? 0);

      const totalCmvManual = qtdExit * priceUn;
      const totalCmvPerda = qtdLoss * priceUn;
      const totalCmvPromocional = qtdPromocional * priceUn;

      const cmvAutomatic = qtdExitAutomatic * priceUn;
      const cmvManual = totalCmvManual;
      const cmvPerda = totalCmvPerda;
      const cmvPromocional = totalCmvPromocional;

      custoTotalManual += totalCmvManual;
      custoTotalPerda += totalCmvPerda;
      custoTotalPromocional += totalCmvPromocional;

      const rowValues = [
        { v: priceUn / 100, fmt: '"R$"#,##0.00' },
        { v: qtdExitAutomatic },
        { v: cmvAutomatic / 100, fmt: '"R$"#,##0.00' },
        { v: qtdExit },
        { v: cmvManual / 100, fmt: '"R$"#,##0.00' },
        { v: qtdLoss },
        { v: cmvPerda / 100, fmt: '"R$"#,##0.00' },
        { v: qtdPromocional },
        { v: cmvPromocional / 100, fmt: '"R$"#,##0.00' },
      ];

      rowValues.forEach((col, idx) => {
        const cell = worksheet.getCell(excelRow, colIndex + idx);
        cell.value = col.v;
        if (col.fmt) cell.numFmt = col.fmt;
      });

      colIndex += dayHeaders.length;
    });

    worksheet.getCell(excelRow, 3).value = getFloatCMV(item.qtdExitAutomatic ?? 0);
    worksheet.getCell(excelRow, 4).value = getFloatCMV(item.qtdExit ?? 0);
    worksheet.getCell(excelRow, 5).value = getFloatCMV(item.qtdLoss ?? 0);
    worksheet.getCell(excelRow, 6).value = getFloatCMV(item.qtdPromotial ?? 0);
    worksheet.getCell(excelRow, 7).value = getFloatCMV(
      (item.qtdExit ?? 0) + (item.qtdLoss ?? 0) + (item.qtdPromotial ?? 0)
    );

    worksheet.getCell(excelRow, 8).value = Number(getFloatCMV(item.priceTotal / 100));
    worksheet.getCell(excelRow, 8).numFmt = '"R$"#,##0.00';

    worksheet.getCell(excelRow, 9).value = Number(getFloatCMV(custoTotalManual / 100));
    worksheet.getCell(excelRow, 9).numFmt = '"R$"#,##0.00';

    worksheet.getCell(excelRow, 10).value = Number(getFloatCMV(custoTotalPerda / 100));
    worksheet.getCell(excelRow, 10).numFmt = '"R$"#,##0.00';

    worksheet.getCell(excelRow, 11).value = Number(getFloatCMV(custoTotalPromocional / 100));
    worksheet.getCell(excelRow, 11).numFmt = '"R$"#,##0.00';

    worksheet.getCell(excelRow, 12).value = Number(getFloatCMV((custoTotalManual + custoTotalPerda + custoTotalPromocional) / 100));
    worksheet.getCell(excelRow, 12).numFmt = '"R$"#,##0.00';
  });

  // ---- download ----
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}